import React from "react";
import {
  SimilarResidentsTable,
  SimilarResidentSearchData,
  Resident,
  H2,
} from "@reside/ui";
import {ResidentAdmissionsButtonWithModal} from "../../../atoms/resident-admissions-modal/ResidentAdmissionsButtonWithModal";

import {Row} from "../../page-admin-residents/types";

export const ListOfPossibleDuplicates = ({
  remoteResidents,
  similarResidentsSearchData,

  shouldShowDuplicatesList,
}: {
  remoteResidents: {resident: Resident; match: string}[];
  similarResidentsSearchData: SimilarResidentSearchData;

  shouldShowDuplicatesList: boolean;
}) => {
  if (!shouldShowDuplicatesList) {
    return null;
  }

  return (
    <>
      <H2 margin="32px 0 16px 0" as="h1">
        Similar residents have been found
      </H2>

      <SimilarResidentsTable
        similarResidents={remoteResidents}
        selectable={false}
        formValues={similarResidentsSearchData}
        residentFilesModal={({rowData}: Row) => (
          <ResidentAdmissionsButtonWithModal rowData={rowData} />
        )}
      />
    </>
  );
};
